import React from 'react';
import styled from 'styled-components';

import FieldWrap from './FieldWrap';
import Typography from '../Typography';
import Caption from './Caption';
import { inputCss } from './styles';

type Props = {
    type?: 'text' | 'number' | 'email' | 'password' | 'search' | 'tel';
    value?: string;
    disabled?: boolean;
    required?: boolean;
    error?: string;
    caption?: string;
    label?: string;
    startIcon?: React.ElementType;
    endIcon?: React.ElementType;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

type InputProps = {
    invalid: boolean;
    hasStartIcon: boolean;
    hasEndIcon: boolean;
};

const InputStyled = styled.input<InputProps>`
    ${inputCss}
    ${({ hasStartIcon }) => (hasStartIcon ? `padding-left: 34px;` : '')}
    ${({ hasEndIcon }) => (hasEndIcon ? `padding-right: 34px;` : '')}
`;

const InputWrap = styled.div`
    position: relative;
`;

const StyledLabel = styled.label`
    margin-bottom: 0;
`;

const Input = React.forwardRef<HTMLInputElement, Props & React.HTMLAttributes<HTMLInputElement>>(
    ({ type = 'text', label, error, caption, disabled, onChange, startIcon, endIcon, ...rest }: Props, ref) => {
        return (
            <FieldWrap>
                <StyledLabel>
                    {label && <Typography type="label">{label}</Typography>}
                    <InputWrap>
                        {startIcon}
                        <InputStyled
                            ref={ref}
                            type={type}
                            invalid={!!error}
                            hasStartIcon={!!startIcon}
                            hasEndIcon={!!endIcon}
                            disabled={disabled}
                            {...rest}
                            onChange={e => !disabled && onChange && onChange(e)}
                        />
                        {endIcon}
                    </InputWrap>
                </StyledLabel>
                <Caption error={!!error}>{error || caption}</Caption>
            </FieldWrap>
        );
    },
);

export default Input;
